import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactHighcharts from "react-highcharts";
import HighchartsMore from "highcharts-more";
import Pareto from "highcharts/modules/pareto";
import SolidGauge from "highcharts/modules/solid-gauge";
import classNames from 'classnames';
import {commercialHoursInInterval, convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import Grid from "@material-ui/core/Grid/Grid";
import ComplexGrid from "../../../common/ComplexGrid";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {checkNull} from "../../../utils/utils";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {};
var perioddata = [];
var cH = null;

const useStyles = makeStyles(theme => ({
    mainContainer:{
        margin: '6px 0px',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        alignContent: 'stretch'
    },
  mainGrid: {
   // backgroundColor: 'cyan',
      margin: '6px 0px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      alignItems: 'stretch',
      alignContent: 'stretch'
  },
  marginAuto:{
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      margin: '8px',
      border: '3px',
      borderColor: 'yellow',
    // display: 'flex',
    //   flexGrow: '0.2',
      // width: '100%',
    //   height: '100%'
  }
}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>[[
        </React.Fragment>
    )
}

export default function RoitreadKPIs(prop) {
  const {series, seriesPerType, filter, isLoading} = prop;
  console.log('kpi series', series)
  const classes = useStyles();


  let cH = 1;
  let obj = {
      numCiclosTotais: 0,
      numCiclosRoletagem: 0,
      numCiclosExtrusao: 0,
      tempoTotalUsoSec: 0,
      avgExtrusoraConsumo: 0,
      sumExtrusoraConsumo: 0,
      avgTempoRoletagem: 0,
      avgTempoExtrusao: 0,
      avgTempoOutros: 0
  }

  let numCiclosTotais = 0;
  let numCiclosExtrusao = 0;
  let tempoTotalCiclosExtrusao = 0;
  let tempoTotal = 0;
  let sumExtrusoraConsumo = 0;

  const estab = filter.estabelecimentos.find( e => e.id = filter.estabelecimentoId)

    cH = commercialHoursInInterval(filter.periodMin, filter.periodMax, estab.cargaHorariaDia);

  if (series) {


      series.map((rp,ix) => {
          numCiclosTotais += rp.numCiclosTotais;
          numCiclosExtrusao += rp.numCiclosExtrusao;
          tempoTotalCiclosExtrusao += rp.sumTempoExtrusao;
          sumExtrusoraConsumo += rp.sumExtrusoraConsumo;
          tempoTotal += rp.sumTempoExtrusao + rp.sumTempoAplicacaoBandaSec + rp.sumTempoRoletagem + rp.sumTempoOutros;
      });




  }

  console.log("ch", cH);

  var percent = Math.round((tempoTotal / 60 / 60) / cH * 100);




  if (isLoading) {return renderLoadingScreen()}

 // console.log('datamaq', dataMaq);

    console.log("tempo Extrusao", tempoTotalCiclosExtrusao , numCiclosExtrusao, Math.floor(tempoTotalCiclosExtrusao / numCiclosExtrusao),convertSecondsToMinutesSecondsFormat(Math.floor(tempoTotalCiclosExtrusao / numCiclosExtrusao) ))

    let tExtrusao = '--';
    if (numCiclosExtrusao >0) {
        tExtrusao =  checkNull(convertSecondsToMinutesSecondsFormat(Math.floor(tempoTotalCiclosExtrusao / numCiclosExtrusao) ),'--');
    }


  return (
    <Grid container xs={12} className={classes.mainContainer}>
        <Grid container item xs={12} lg={12} xl={12} className={classes.mainGrid}>
            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    leftSideGrid={true}
                    iconState="success"
                    icon="business_money-coins"
                    mainvalue={<span><small></small>
                        {checkNull(numCiclosTotais,'--')}</span>}
                    title={<span>{ "PRODUÇÃO TOTAL".padEnd(15)}</span>}
                    description={<span>ciclos totais.</span>}
                    unit="ciclos"
                />
            </Grid>
            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    leftSideGrid={true}
                    iconState="success"
                    icon="business_money-coins"
                    mainvalue={<span><small></small>
                        {checkNull(numCiclosExtrusao,'--')}</span>}
                    title={<span>EXTRUSÕES</span>}
                    description={<span>em {cH} horas disponíveis.</span>}
                    unit="ciclos"
                />
            </Grid>

            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    mainvalue={tExtrusao}
                    title='TEMPO EXTRUSÃO'
                    unit='(hh:)mm:ss'
                    description={<span>tempo médio de cada ciclo para aplicação do material.</span>}

                />
            </Grid>

            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    rightSideGrid={true}
                    mainvalue={<span>{checkNull((sumExtrusoraConsumo/numCiclosExtrusao).toFixed(2),'--') }</span>}
                    title={<span>CONSUMO MÉDIO MATERIAL</span>}
                    description={<span> total de {(sumExtrusoraConsumo).toFixed(1) }kg consumidos.</span>}
                    unit={<span>Kg</span>}
                />
            </Grid>
            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    rightSideGrid={true}
                    mainvalue={<span>{ checkNull(convertSecondsToMinutesSecondsFormat(Math.floor(tempoTotal / numCiclosTotais)),'--')  }</span>}
                    title={<span>TEMPO MEDIO CICLO</span>}
                    description={<span>tempo médio total por ciclo na roitread. Total de {  convertSecondsToMinutesSecondsFormat(Math.floor(tempoTotal)) } no periodo.</span>}
                    unit={<span>{`(hh:)mm:ss`}</span>}
                />
            </Grid>
        </Grid>
        {
            series.map( (c,ix) => {
                return(

        <Grid key={ix} container item xs={12} lg={12} xl={12} className={classes.mainGrid}>

            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    leftSideGrid={true}
                    iconState="success"
                    icon="business_money-coins"
                    mainvalue={<span><small></small>
                        {checkNull(c.numCiclosTotais,'--')}</span>}
                    title={<span>{ ("COLUNA "+c.posicao.toString()).padEnd(15)}</span>}
                    description={<span>ciclos totais no periodo.</span>}
                    unit="ciclos"
                />
            </Grid>

            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    mainvalue={
                        Math.round(
                          (
                        (c.sumTempoExtrusao + c.sumTempoAplicacaoBandaSec + c.sumTempoRoletagem + c.sumTempoOutros)
                          / 60 / 60) / cH * 100)


                        + '%' }
                    title='UTILIZAÇÃO'
                    unit='percentual'
                    description={<span> {
                        convertSecondsToMinutesSecondsFormat(
                                  Math.floor(c.sumTempoExtrusao + c.sumTempoAplicacaoBandaSec + c.sumTempoRoletagem + c.sumTempoOutros)) } em {cH} horas disponíveis.</span>}

                />
            </Grid>


            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    mainvalue={checkNull(convertSecondsToMinutesSecondsFormat(c.avgTempoAplicacaoBandaSec),'--') }
                    title='APLICAÇÃO BANDA'
                    unit='mm:ss'
                    description={<span>tempo médio de cada ciclo para aplicação do material.</span>}

                />
            </Grid>
            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    mainvalue={checkNull(convertSecondsToMinutesSecondsFormat(c.avgTempoRoletagem),'--') }
                    title='ROLETAGEM'
                    unit='mm:ss'
                    description={<span>tempo médio de cada ciclo para roletagem</span>}

                />
            </Grid>
            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                    className={classes.marginAuto}
                    mainvalue={checkNull(convertSecondsToMinutesSecondsFormat(c.avgTempoOutros),'--')}
                    title='OUTROS'
                    unit='mm:ss'
                    description={<span>tempo médio de cada ciclo para outros.</span>}

                />
            </Grid>
            <Grid item xs className={classNames(classes.marginAuto)}>
                <ComplexGrid
                        className={classes.marginAuto}
                        mainvalue={checkNull(convertSecondsToMinutesSecondsFormat(
                                Math.floor((c.sumTempoExtrusao + c.sumTempoAplicacaoBandaSec + c.sumTempoRoletagem + c.sumTempoOutros) /
                                c.numCiclosTotais )),'--')
                                }
                        title='TOTAL'
                        unit='mm:ss'
                        description={<span>tempo médio de total de cada ciclo na coluna</span>}

                />
            </Grid>
        </Grid>
                )
            })
        }
    </Grid>

  )
}

